import { VoyageFinalizedIndPolicy } from "constants/charge/VoyageFinalizedIndPolicy";
import _ from "lodash";

export const VoyageFinalizedIndDroOpts = () => {

    const getDroOptsModel = () => {
        let ret: string[] = [VoyageFinalizedIndPolicy.F, VoyageFinalizedIndPolicy.UF];
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    return {
        getDroOptsModel
    }
}